import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
import { LpIcon } from "../icon";
export const LP_BANNER_VARIANTS = ["default", "alert", "error", "secondary"];
export const LP_BANNER_SIZES = ["sm", "base"];
const managedAttrs = [
    "data-lp-component",
    "class",
    "data-variant",
    "data-size",
    "role",
];
export function LpBanner({ title, description, icon, iconWeight = "fill", actions, variant = "default", size = "base", className, attributes, }) {
    const role = variant === "error" || variant === "alert" ? "alert" : "status";
    return html `
        <section
            data-lp-component="Banner"
            class="${cn("lp-banner", className, attributes?.class)}"
            data-variant="${variant}"
            data-size="${size}"
            role="${role}"
            ${spreadAttrs(attributes, { omit: managedAttrs })}
        >
            ${icon
        ? html `
                    <span class="lp-banner_icon" aria-hidden="true">
                        ${LpIcon({ name: icon, weight: iconWeight })}
                    </span>
                `
        : ""}
            <div class="lp-banner_content">
                <div class="lp-banner_title">${title}</div>
                ${description
        ? html `<div class="lp-banner_description">${description}</div>`
        : ""}
            </div>
            ${actions ? html `<div class="lp-banner_actions">${actions}</div>` : ""}
        </section>
    `;
}
